<main class="main-root">
    <section class="banner-section banner-static-section">
        <div class="banner-card-full">
            <div class="banner-image">
                <picture>
                    <source media="(max-width: 1199px)" srcset="./assets/images/pricing/mobile-pricing-banner.jpg">
                    <img src="./assets/images/pricing/pricing-banner.jpg" alt="banner" class="banner-img" />
                </picture>
            </div>
            <div class="container container-full">
                <div class="banner-card-full-inner">
                    <h1>{{ 'One step away from' | translate }} <br><b>{{ 'Profitability!' | translate }}</b></h1>
                </div>
            </div>
        </div>
    </section>

    <section class="content-section vrt-content-section">
        <div class="container container2">
            <div class="content-inner vrt-content-inner">
                <h1 class="mobile-show">{{ 'One Step Away' | translate }} <br> {{ 'from Profitability!' | translate }}</h1>
                <div class="keen-slider vrt-cnt-keen-slider hide-desktop" #verticlesliderRef>
                    <div class="keen-slider__slide">
                        <div class="vrt-cnt-row">
                            <div class="vrt-icon-dv"> <img src="./assets/images/pricing/icon-refresh.png" alt="icon" class="img-fluid img-icon" /> </div>
                            <div class="vrt-txt-dv"><p>{{ 'Grow your business and connect with more customers' | translate }} <b>{{ 'seamlessly.' | translate }}</b></p></div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="vrt-cnt-row">
                            <div class="vrt-icon-dv"> <img src="./assets/images/pricing/icon-chart.png" alt="icon" class="img-fluid img-icon" /> </div>
                            <div class="vrt-txt-dv"><p>{{ 'See the results fast! Get' | translate }} <b>{{ 'immediate benefits' | translate }}</b> {{ 'from engaging customers.' | translate }}</p></div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="vrt-cnt-row">
                            <div class="vrt-icon-dv"> <img src="./assets/images/pricing/icon-touch.png" alt="icon" class="img-fluid img-icon" /> </div>
                            <div class="vrt-txt-dv"><p>{{ 'It\'s super' | translate }} <b>{{ 'easy to use' | translate }}</b>. {{ 'You and your customers will love it!' | translate }}</p></div>
                        </div>
                    </div>
                </div>

                <div class="keen-slider vrt-cnt-keen-slider hide-mobile">
                    <div class="keen-slider__slide">
                        <div class="vrt-cnt-row">
                            <div class="vrt-icon-dv"> <img src="./assets/images/pricing/icon-refresh.png" alt="icon" class="img-fluid img-icon" /> </div>
                            <div class="vrt-txt-dv"><p>{{ 'Grow your business and connect with more customers' | translate }} <b>{{ 'seamlessly.' | translate }}</b></p></div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="vrt-cnt-row">
                            <div class="vrt-icon-dv"> <img src="./assets/images/pricing/icon-chart.png" alt="icon" class="img-fluid img-icon" /> </div>
                            <div class="vrt-txt-dv"><p>{{ 'See the results fast! Get' | translate }} <b>{{ 'immediate benefits' | translate }}</b> {{ 'from engaging customers.' | translate }}</p></div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="vrt-cnt-row">
                            <div class="vrt-icon-dv"> <img src="./assets/images/pricing/icon-touch.png" alt="icon" class="img-fluid img-icon" /> </div>
                            <div class="vrt-txt-dv"><p>{{ 'It\'s super' | translate }} <b>{{ 'easy to use' | translate }}</b>. {{ 'You and your customers will love it!' | translate }}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="beyond-grid-section free-grid-section" #beyondGridSection>
        <div class="container container2">
            <div class="beyond-grid-inner">
                <div class="heading-dv heading-free-dv">
                    <h2>{{ 'Get started for FREE!' | translate }}</h2>
                    <p>{{ 'Experience first hand how we scale your business and deliver memorable customer experiences.' | translate }}</p>
                </div>
    
                <div class="keen-slider grid-slider" #gridSlider>
                    <div class="keen-slider__slide">
                        <div class="beyond-grid-card">
                            <div class="beyond-grid-card-inner">
                                <div class="image-dv">
                                    <img src="./assets/images/pricing/biz-free4.jpg" alt="img" class="img-fluid" />
                                </div>
                                <div class="content-dv">
                                    <h3>{{ 'Biz Listing' | translate }}</h3>
                                    <div class="desc-dv">
                                        <p>{{ 'Boost your presence with enhanced searchability and curated listings' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="beyond-grid-card">
                            <div class="beyond-grid-card-inner">
                                <div class="image-dv">
                                    <img src="./assets/images/pricing/biz-free2.jpg" alt="img" class="img-fluid" />
                                </div>
                                <div class="content-dv">
                                    <h3>{{ 'Promotion Slots' | translate }}</h3>
                                    <div class="desc-dv">
                                        <p>{{ 'Reach customers instantly with targeted deals and offers*' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="beyond-grid-card">
                            <div class="beyond-grid-card-inner">
                                <div class="image-dv">
                                    <img src="./assets/images/pricing/biz-free3.jpg" alt="img" class="img-fluid" />
                                </div>
                                <div class="content-dv">
                                    <h3>{{ 'Digital Vouchers' | translate }}</h3>
                                    <div class="desc-dv">
                                        <p>{{ 'Enhance dining experience with instant discounts*' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="keen-slider__slide">
                        <div class="beyond-grid-card">
                            <div class="beyond-grid-card-inner">
                                <div class="image-dv">
                                    <img src="./assets/images/pricing/biz-free1.jpg" alt="img" class="img-fluid" />
                                </div>
                                <div class="content-dv">
                                    <h3>{{ 'Loyalty Points' | translate }}</h3>
                                    <div class="desc-dv">
                                        <p>{{ 'Attracts repeat visits with intuitive membership programs.' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="free-terms-desc-dv">
                    <p>*{{ 'enjoy additional promotional opportunities with our Growth+ and Premium+' | translate }}</p>
                </div>
            </div>
    
            <div class="content-inner">
                <div class="btn-center-dv">
                    <a href="javascript:void(0)" class="btn btn-primary-common" (click)="handleRegisterBizClick()">{{ 'REGISTER YOUR BIZ FREE' | translate }}</a>
                </div>
            </div>
        </div>
    </section>

    <div class="growth-pricing-parent">
        <section class="growth-section" *ngIf="!pricingCalculateStarted" [@fadeAnimation]>
            <div class="container">
                <div class="growth-dv">
                    <div class="heading-dv">
                        <h2>{{ 'Unlock more business' | translate }}</h2>
                    </div>

                    <div class="growth-root">
                        <div class="growth-row growth-growth-row">
                            <div class="growth-left-col">
                                <h3>{{ 'Upgrade to' | translate }}</h3>
                                <h2>{{ 'Growth+' | translate }}</h2>
                                <div class="growth-content-dv">
                                    <h4>{{ 'Additional 3 promo and redemption slots' | translate }}</h4>
                                    <ul>
                                        <li>{{ 'Layer rewards and boost customer engagement.' | translate }}</li>
                                        <li>{{ 'More ways to earn and redeem points at the same time.' | translate }}</li>
                                        <li>{{ 'Richer, more flexible loyalty experience' | translate }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="growth-right-col">
                                <div class="growth-price-dv">
                                    <p>{{ 'Starting from' | translate }}</p>
                                    <div class="price-text">Rp. 150k<span>/</span><small>mth*</small></div>
                                </div>
                                <div class="btn-dv">
                                    <a class="btn btn-secondary-common" (click)="startPricingCalculation()">{{ "LET'S DO THIS" | translate }}</a>
                                </div>
                            </div>
                        </div>

                        <div class="growth-row premium-growth-row">
                            <div class="growth-left-col">
                                <h3>{{ 'Upgrade to' | translate }}</h3>
                                <h2>{{ 'Premium+' | translate }}</h2>
                                <div class="growth-content-dv">
                                    <h4>{{ 'Unlimited promos and vouchers' | translate }}</h4>
                                    <ul>
                                        <li>{{ 'Run unlimited promos and redemptions to fully customize loyalty strategy.' | translate }}</li>
                                        <li>{{ 'Tailor offers to maximize engagement.' | translate }}</li>
                                        <li>{{ 'Adapt promotions seamlessly for new products, seasons, or trends.' | translate }}</li>
                                        <li>{{ 'Keep customers returning with customized incentives.' | translate }}</li>
                                    </ul>
                                </div>

                                <div class="growth-content-dv">
                                    <h4>{{ 'Make orders at table' | translate }}</h4>
                                    <ul>
                                        <li>{{ 'Increased efficiency and faster service' | translate }}</li>
                                        <li>{{ 'Enhanced customer experience' | translate }}</li>
                                        <li>{{ 'Data insights and customer engagement' | translate }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="growth-right-col">
                                <div class="growth-price-dv">
                                    <p>{{ 'Starting from' | translate }}</p>
                                    <div class="price-text">Rp. 425k<span>/</span><small>mth*</small></div>
                                </div>
                                <div class="btn-dv">
                                    <a class="btn btn-secondary-common" (click)="startPricingCalculation();growthPlusSelected=false">{{ "LET'S DO THIS" | translate }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section *ngIf="pricingCalculateStarted" [@fadeAnimation]>
            <div>
                <app-personalize-plan 
                  [optionASelected]="growthPlusSelected ? true : false" 
                  [optionBSelected]="growthPlusSelected ? false : true" 
                  [optionCSelected]="growthPlusSelected ? false : true"
                  (closeCalculator)="closeCalculator()"
                >
                </app-personalize-plan>
            </div>
        </section>
    </div>
    <section class="story-section">
        <div class="container container2">
            <div class="story-dv">
                <div class="heading-dv">
                    <h2>{{ 'Hear their story' | translate }}</h2>
                </div>

                <div class="keen-slider grid-story-slider" #gridStorySlider>
                    <div class="keen-slider__slide">
                        <div class="grid-story-card">
                            <div class="grid-story-card-inner">
                                <div class="image-dv">
                                    <img src="./assets/images/why-hungery/story1.webp" alt="img" class="img-fluid" />
                                </div>
                                <div class="content-dv">
                                    <div class="desc-dv">
                                        <p>“{{ 'Customers love the convenience of being able to easily order and pay through the app, and we\'ve been able to streamline our operations and reduce wait times.' | translate }}“</p>
                                    </div>
                                    <div class="user-story-dv">
                                        <div class="user-story-img">
                                            <img src="./assets/images/why-hungery/1.jpg" alt="img" class="img-fluid" />
                                        </div>
                                        <div class="user-story-txt">
                                            <h4>{{ 'Moley & Moley' | translate }}</h4>
                                            <p>{{ 'Yuicery Co-Founders' | translate }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="keen-slider__slide">
                        <div class="grid-story-card">
                            <div class="grid-story-card-inner">
                                <div class="image-dv">
                                    <img src="./assets/images/why-hungery/story2.jpg" alt="img" class="img-fluid" />
                                </div>
                                <div class="content-dv">
                                    <div class="desc-dv">
                                        <p>“{{ 'Customers love the convenience of being able to easily order and pay through the app, and we\'ve been able to streamline our operations and reduce wait times.' | translate }}“</p>
                                    </div>
                                    <div class="user-story-dv">
                                        <div class="user-story-img">
                                            <img src="./assets/images/why-hungery/1.jpg" alt="img" class="img-fluid" />
                                        </div>
                                        <div class="user-story-txt">
                                            <h4>{{ 'Moley & Moley' | translate }}</h4>
                                            <p>{{ 'Yuicery Co-Founders' | translate }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="btn-center-dv">
                    <a href="javascript:void(0)" class="btn btn-primary-common" (click)="handleRegisterBizClick(true)">{{ "I'M READY TO JOIN" | translate }}</a>
                </div>
            </div>
        </div>
    </section>

    <section class="lets-do-this-section">
        <div class="banner-image">
            <picture>
                <source media="(max-width: 767px)" srcset="./assets/images/why-hungery/mobile-lets-do.jpg">
                <img src="./assets/images/why-hungery/lets-do-this.jpg" alt="lets-do-this" class="lets-do-this-img" />
            </picture>
        </div>

        <div class="container container-full">
            <div class="lets-do-this-div">
                <h2>{{ 'Let’s Do This!' | translate }} <br></h2>
            </div>
        </div>
    </section>

    <section class="we-are-section">
        <div class="container container2">
            <div class="we-are-div">
                <div class="content-inner">
                    <h2 class="mobile-show">{{ 'Let’s Do This!' | translate }}</h2>
                    <p><strong>{{ 'We’re committed' | translate }}</strong> {{ 'to helping you grow your business and building an exciting and thriving Hungery community.' | translate }}</p>
                </div>
                <div class="btn-group-center-dv">
                    <a href="javascript:void(0)" class="btn btn-primary-common" (click)="handleRegisterBizClick()">{{ 'REGISTER YOUR BIZ FREE' | translate }}</a>
                    <a href="javascript:void(0)" (click)="openGetInTouchModal()" class="btn btn-secondary-common">{{ 'GET IN TOUCH' | translate }}</a>
                </div>
            </div>
        </div>
    </section>

    <section class="newsletter-section">
        <div class="container container2">
            <div class="newsletter-div">
                <div class="heading-dv">
                    <h2>Don’t miss what’s cooking!</h2>
                    <p>Be updated with the practices, tools and techniques used by our  best F&B outlets - and what’s cooking in HUNGERY.</p>
                </div>
                <div class="form-dv">
                    <div class="form-group">
                        <input type="email" class="form-control" placeholder="email@domain.com" />
                    </div>
                    <div class="btn-submit-dv">
                        <button class="btn btn-text-black">SIGN-UP NEWSLETTER</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>

<app-login #loginModal></app-login>